module.exports = __webpack_public_path__ + "img/img-7mobile.9666d07f.png";